import { useDispatch, useSelector } from "react-redux";
import { downloadOrdersReportExcel } from "../thunks/downloadOrdersReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useOrderExcelReportDownloader = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.reports.exchbusiness.clientOverview.fetchState
	);
	const dispatch = useDispatch();
	const download = React.useCallback(() => dispatch(downloadOrdersReportExcel()), [dispatch]);

	return [download, fetchState] as [typeof download, typeof fetchState];
};
